// extracted by mini-css-extract-plugin
export var partners = "partners-module--partners--2hvU5";
export var link = "partners-module--link--2cxet";
export var img = "partners-module--img--1OS9o";
export var dark = "partners-module--dark--BCkpF";
export var jsAnimInit = "partners-module--jsAnimInit--2xXzP";